import { Link } from 'react-router-dom';
import image from "../../assets/img/logo-2.png";
// import bgImage from "../../assets/img/portfolio/portfolio-8.jpg";


const AboutMain = () => {
    return (
        <>
            <div className="mission__area section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 lg-mb-25">
                            <div className="mission__area-left mr-40 xl-mr-0">
                                <span className="subtitle wow fadeInLeft" data-wow-delay=".4s">Our Mission</span>
                                <h2 className="title_split_anim">Dedicated to Delivering Value and Excellence</h2>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="mission__area-right">
                                <div className="row">
                                    <p className="wow fadeInUp mt-40" data-wow-delay=".6s">
                                        Our mission is to provide comprehensive solutions in engineering construction, supervision, consultancy, material supply, export and import, software development, design, drawing, and architecture. We are dedicated to deliver innovative, high-quality, and sustainable services that meet the evolving needs of our clients. With a commitment to excellence, integrity, and technological advancement, we aim to drive progress in infrastructure, trade, and digital transformation while creating lasting value for communities and industries.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mission__area section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 lg-mb-25">
                            <div className="mission__area-left mr-40 xl-mr-0">
                                <span className="subtitle wow fadeInLeft" data-wow-delay=".4s">Our Vission</span>
                                <h2 className="title_split_anim">Shaping Tomorrow’s Built Environment Today</h2>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="mission__area-right">
                                <div className="row">
                                    <p className="wow fadeInUp mt-40" data-wow-delay=".6s">
                                        Our vision is to be a globally recognized leader in engineering, architecture, construction, and technology. We strive to set new industry standards by integrating cutting-edge design, efficient project execution, advanced software solutions, and strategic trade partnerships. Through innovation, sustainability, and collaboration, we aim to shape a smarter, more resilient, and aesthetically inspiring built environment for future generations.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <div className="about__five section-padding pt-0">
                <div className="container">
                    <div className="row al-center">
                        <div className="col-lg-5 lg-mb-25">
                            <div className="about__five-image wow img_left_animation">
                                <img src={image} alt="image" />
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div className="about__five-right ml-70 xl-ml-0">
                                <div className="about__five-right-title">
                                    <span className="subtitle wow fadeInLeft" data-wow-delay=".4s">About Our Company</span>
                                    <h2 className="title_split_anim">Trusted Partner in Construction and Design</h2>
                                </div>
                                <div className="features wow fadeInUp" data-wow-delay=".3s" style={{backgroundImage: `url(${bgImage})`}}>
                                    <h3>Building Trust<br/>Since 1989</h3>
                                </div>
                                <p className="wow fadeInUp" data-wow-delay=".6s">Our journey began with a commitment to excellence, and that commitment remains at the core of our operations today. We’ve grown from a small local business into a trusted partner for both residential and commercial.</p>
                                <div className="item_bounce">
                                    <Link className="build_button mt-20" to="/portfolio">See Projects<i className="flaticon-right-up"></i></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
        </>
    );
};

export default AboutMain;